<!--
© Copyright 2015-2026 Personalized Privacy Assistant Project, Carnegie Mellon University - All Rights Reserved - US Patent 11,768,949, US Patent 10,956,586, US Patent 12,235,973, and additional USPTO and EPO patents pending.
This code is proprietary and confidential. For any questions about this code, including licensing, please contact Prof. Norman Sadeh (sadeh@cs.cmu.edu).
-->
<template>
  <div class="h-100">
    <div class="card bg-light mb-3 h-100">

      <!-- Transfer IRR Modal -->
      <div class="modal fade" id="transferModal" tabindex="-1" role="dialog" aria-labelledby="transferModalLabel" aria-hidden="true" style="z-index:999999;">
        <div class="modal-dialog modal-lg" role="document" style="max-width: 750px;">
          <div class="modal-content">
            <div class="modal-header border-0" style="display: flex; justify-content: flex-end; padding: 15px 20px;">
              <button type="button" class="close" data-dismiss="modal" aria-label="Cancel" style="position: static; margin-left: auto;">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

              <div class="modal-body" style="padding: 0 30px 30px 30px;">
                <h4 style="color: #0051BA; font-weight: bold; margin-bottom: 20px;">Transfer Registry Ownership</h4>
                <p style="font-size: 16px; line-height: 1.6; margin-bottom: 25px;"><strong>By clicking "Request Transfer", your membership in this registry will end immediately and be transferred to the new registry owner.</strong> If the new resource owner is already an admin in this registry, they will be escalated to the owner role. The new owner must have an existing IoTPI account.</p>

                <form id="transferForm" method="POST" enctype="multipart/form-data" :action="baseUrls.transferUrl">
                  <input type="hidden" name="_token" :value="csrf_token">
                  <input type="hidden" name="irr" :value="irr.id">

                  <div class="form-group" style="display: flex; align-items: flex-start; gap: 12px; margin-bottom: 12px;">
                    <label for="new_owner_email" style="font-weight: bold; font-size: 16px; color: #333; white-space: nowrap; padding-top: 8px; flex-shrink: 0;">New Owner Email</label>
                    <div style="flex-grow: 1;">
                      <input type="email" id="new_owner_email" name="new_owner_email" placeholder="" required="required" class="form-control" @input="validateEmail" style="margin-bottom: 8px;">
                      <small id="new_owner_email-help" class="form-text text-muted">Note: The email address of the new owner must be what they use for their IoTPI account</small>
                    </div>
                  </div>

                  <div class="d-flex gap-2 pt-2" style="gap: 10px;">
                    <button type="button" class="btn" style="background-color: #0051BA; color: white; border-radius: 25px; padding: 8px 16px; border: none; font-weight: 500; font-size: 14px; cursor: pointer;" data-dismiss="modal">Cancel</button>
                    <button type="submit" id="transfer-form-button" class="btn" style="background-color: #F4A582; color: white; border-radius: 25px; padding: 8px 16px; border: none; font-weight: 500; font-size: 14px; cursor: pointer;" :disabled="!isEmailValid" :style="{opacity: isEmailValid ? 1 : 0.6, cursor: isEmailValid ? 'pointer' : 'not-allowed'}">Request Transfer</button>
                  </div>
                </form>
              </div>

          </div>
        </div>
      </div>


      <div class="card-body">
        <div class="card-text">
          <center>
            <h1>Registry:&nbsp;&nbsp;{{ irr.name }}</h1>
            <p><small>Registry ID # {{ irr.id }}</small></p>
            <p class="lead text-muted">{{ irr.description }}</p>
          </center>
          <!--
          <table class="table">
            <tbody>
              <tr>
                <th><h6>RESOURCES:</h6></th>
                <th><h6>{{ resources.length }}</h6></th>
              </tr>
              <tr>
                <th><h6>CONTRIBUTORS:</h6></th>
                <th><h6>{{ numUsers }}</h6></th>
              </tr>
              <tr>
                <th v-if="!permissions.currentPermissions.IRR_CHANGE_SETTINGS"><h6>CREATED:</h6></th>
                <th v-if="!permissions.currentPermissions.IRR_CHANGE_SETTINGS"><h6>{{ irr.created_at.split(" ", 1)[0] }}</h6></th>
              </tr>
            </tbody>
          </table>
        -->
          <div v-if="permissions.currentPermissions.IRR_CHANGE_SETTINGS" class="row">
              <div class="col-6">
                <a :href="'/irr/' + irr.id + '/edit'" class="btn btn-registry btn-block" role="button" aria-disabled="true">EDIT SETTINGS</a>
                <a :href="'/irr/' + irr.id + '/publishrequests'" class="btn btn-resource btn-block" role="button" aria-disabled="true">PUBLICATION REQUESTS<br />({{ numPendingPublishRequests }} Pending)</a>
              </div>
              <div class="col-6">
                <a :href="'/irr/' + irr.id + '/users'" class="btn btn-registry btn-block" role="button" aria-disabled="true">REGISTRY USERS<br />({{ numUsers }} {{ numUsers === 1 ? 'Member' : 'Members' }})</a>
                <a v-if="permissions.currentPermissions.SYS_TRANSFER_IRR || irr.isOwner" class="btn btn-registry btn-block" role="button" data-toggle="modal" data-target="#transferModal" aria-disabled="true">TRANSFER OWNERSHIP</a>
                <!-- <a :href="'/irr/' + irr.id + '/accessrequests'" class="btn btn-secondary btn-block" role="button" aria-disabled="true">ACCESS REQUESTS</a> -->
              </div>
          </div>
          <!-- <div v-else-if="!permissions.currentPermissions.IRR_SUBMIT_RESOURCE" class="row">
            <div class="col-12">
              <a :href="'/irr/' + irr.id + '/requestaccess'" class="btn btn-registry btn-block" role="button" aria-disabled="true">REQUEST CONTRIBUTOR ACCESS</a>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
      props: {
        irr: Object,
        permissions: Object,
        resources: Array,
        numUsers: Number,
        numPendingPublishRequests: Number,
        baseUrls: Object,
        csrf_token: String,
      },
      data() {
        return {
          isEmailValid: false,
        }
      },
      mounted(){
        const urlParams = new URLSearchParams(window.location.search);

        //check for 'transfer' in query string, display transfer modal if applicable
        if(this.permissions.currentPermissions.SYS_TRANSFER_IRR || this.irr.isOwner) {
          if(urlParams.get('transfer') == 1) {
            $('#transferModal').modal('show');
          }
        } else {
          $('#transferModal').html('');
        }
      },
      methods: {
        validateEmail() {
          const email = document.getElementById('new_owner_email').value;
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          this.isEmailValid = emailRegex.test(email);
        }
      },
      computed: {
        daysLive: function() {
          var currentDate = new Date();
          var createdDate = new Date(this.irr.created_at);
          var difference = (currentDate - createdDate) / 1000 / 86400;
          return (difference < 1) ? 'less than a day' : Math.floor(difference);
        }
      }
    }
</script>
